/**
 * Created by danielr on 6/16/15.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var AuthenticationServerModel = require("manager-models/data-sources/integrations/authentication/AuthenticationServerModel");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var AuthenticationTypeModelBuilder = require("manager-models/data-sources/integrations/authentication/AuthenticationTypeModelBuilder");
    var ApiResources = require("assets/data/apiResources.json");

    var FETCH_METHOD = "GET";
    var URL_PARAMETERS = "&select=$all&acr_values=ALL";
    var NAME = "AuthenticationServerCollection";

    var AuthenticationServerCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AuthenticationServerCollection = RevisionedCollection.extend({
            name: NAME,
            model: AuthenticationServerModel,
            resource: ApiResources.AccountConfig.Connectors,

            fetch: function(options) {
                options = options || {};
                if (options.fetchOptions && !_.isUndefined(options.fetchOptions.reset)) {
                    options.reset = options.fetchOptions.reset;
                }
                return RevisionedCollection.prototype.fetch.call(this, options);
            },

            fetchSuccess: function(collection, response, options){
                collection.each(function(model) {
                    model.populateAuthTypeModel();
                });
            },

            url: function(){ //we need to override backbone to not include '/' and the temp id we give to the model before deleting
                var url = RevisionedCollection.prototype.url.apply(this, arguments);
                url = url + URL_PARAMETERS;
                return url;
            },

            getFetchMethod: function(){ //used by fetcher
                return FETCH_METHOD;
            },

            isAuthEmpty: function() {
                return !this.getFirstAuthModel();
            },

            getFirstAuthModel: function() {
                var firstAuthModel;
                _.some(this.models, _.bind(function(authModel) {
                    if(authModel.getAuthTypeModel()) {
                        if (!authModel.isUnauthModel()) {
                            firstAuthModel = authModel;
                            return true;
                        }
                    }
                }, this));
                return firstAuthModel;
            },

            getFirstUnauthModel: function() {
                var firstUnauthModel;
                _.some(this.models, _.bind(function(unauthModel) {
                    if(unauthModel.getAuthTypeModel() && (unauthModel.getAuthType() === AuthenticationServerModel.TYPES.OAUTH2_IMPLICIT || unauthModel.getAuthType() === AuthenticationServerModel.TYPES.OAUTH2_CODE)) {
                        if(unauthModel.isUnauthModel()) {
                            firstUnauthModel = unauthModel;
                            return true;
                        }
                    }
                }, this));
                return firstUnauthModel;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    AuthenticationServerCollection.NAME = NAME;

    return AuthenticationServerCollection;
});
